<script lang="ts" setup>
import { API } from "@/api/api";
import { useSnackbarStore } from "@/store/snackbar.store";
import { useAppStore } from "@/store/app.store";
import { type MessageDto } from "@/api/chat/dto/message.dto";

const showMenu = defineModel<boolean>({ default: false });

const api = new API();

const props = defineProps<{
  top: number;
  left: number;
  threadId: number;
  message: MessageDto;
}>();

const emits = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
}>();

const { showSnackbarError } = useSnackbarStore();
const { dispatcher } = useAppStore();

async function deleteMessage() {
  try {
    const isConfirmed = confirm("Are you sure you want to delete this message?");

    if (!isConfirmed) {
      return;
    }

    const response = await api.chat.deleteMessage(props.threadId, props.message.id);

    if (!response.success) {
      showSnackbarError("Error while deleting message");
    }

    emits("update:modelValue", false);
  } catch (error) {
    showSnackbarError("Error while deleting message");
  }
}
</script>

<template>
  <v-menu
    v-model="showMenu"
    :close-on-content-click="false"
    :style="`position: absolute; top: ${top}px; left: ${left}px`"
    offset="40"
  >
    <v-list>
      <v-list-item v-if="dispatcher?.isSuperAdmin" @click="deleteMessage">
        <v-list-item-title>
          <div class="d-flex align-center cursor-pointer">
            <v-icon color="grey-darken-3" size="24">mdi-delete-outline</v-icon>

            <span class="font-size-16 text-grey-darken-3 ml-3">Delete</span>
          </div>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
